import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  controls: "",
  class: "col-12"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "text-grey mb-4"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "p-2"
}
const _hoisted_9 = {
  key: 1,
  class: "p-2"
}
const _hoisted_10 = { class: "p-2" }

import PersonalTable from "@/components/PersonalTable.vue";
    import Api from "@/services/api";
    import { Category, Product, Property } from "@/services/types";
    import { ElButton, ElIcon, ElInput, ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
    import { onBeforeMount, reactive, ref, watchEffect } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { useStore } from "vuex";
    type Image = {
        id?: number
        url?: string
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductView',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    const {id} = route.params
    const loading = ref<boolean>(true)
    const editProp = ref<number>(-1)
    const newProp = reactive<Property>({
        property: '',
        value: '',
        id: -5,
        loading: false
    })
    const updating = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const checks = ref<number[]>([])
    const store = useStore()

    const selectedFiles = ref<FileList | null>(null)

    const handleFiles = (event: Event) => {
        const target = event.target as HTMLInputElement
        selectedFiles.value = target.files
        console.log(selectedFiles.value)
    }

    const deleteChecks = async () => {
        if (checks.value.length < 1) {
            return
        }

        loading.value = true
        const params = new URLSearchParams();

        checks.value.forEach((value: number)  => {
            params.append('images[]', value.toString());
        });
        try {
            const res = await Api.delete(`admin/products/images/${id}?${params.toString()}`)
            console.log(res)
            product.images = res.data.product.images
            checks.value = []
        } catch(e) {
            ElMessage.error("Ocorreu um erro" + e)
            console.log(e)
        } finally {
            loading.value = false
        }
    }

    const sendImages = async () => {
        if (!selectedFiles.value || selectedFiles.value.length === 0) {
            console.warn("Nenhum arquivo selecionado")
            return
        }

        console.log(90)

        loading.value = true
        const formData = new FormData()
        for (let i = 0; i < selectedFiles.value.length; i++) {
            formData.append('images[]', selectedFiles.value[i])
        }
        try {
            const res = await Api.post("admin/products/images/" + id, formData, formData)
            product.images = res.data.product.images
            console.log(res)
            selectedFiles.value = []
        } catch(e) {
            console.log(e)
            ElMessage.error("Ocorreu um erro " + e)
        } finally {
            loading.value = false
        }
    }

    const product = reactive<Product>({
        description: '',
        name: '',
        price: 0,
        properties: [],
        images: [],
        categories: [],
    })

    const rules = reactive<FormRules<Product>>({
        name: [{required: true, message: 'Insira o nome do produto'}],
        price: [{required: true, message: 'Informe o preco'}],
        quantity: [{required: true, message: 'Informe a quantidade'}],
        categories: [{required: true, message: 'Escolha pelo menos uma categoria'}],
        description: [{required: true, message: 'Descreva este produto'}],
    })

    const categories = reactive<Array<Category>>([])
    const isVideoFile = (filename: string): boolean => {
        const videoExtensions = [".mp4", ".avi", ".mpeg", ".quicktime", ".webm"];
        return videoExtensions.some(ext => filename.endsWith(ext));
    }

    const getProduct = async () => {
        console.log(90000)
        loading.value = true
        const res = await Api.get('admin/products/' + id)
        if (res.status == 200) {
            const p = res.data.product   
            product.name = p.name
            product.description = p.description
            product.price = p.price
            product.quantity = p.quantity
            product.promoction = p.promoction
            product.images = p.images
            product.id = p.id
            product.active = p.active
            product.categories = p.categories.map((c: Category) => c.id)
            product.created_at = p.created_at
            product.properties = p.properties.filter((prop: Property) => prop.value != null)                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
        } else if (res.status != 404) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message, {type: "error"}).then(() => router.push('/products')).catch(() => router.push('/products'))
        }
        loading.value = false
    }

    onBeforeMount(async () => {
        loading.value = true
        console.log(80000)
        const res1 = await Api.get('admin/categories')
        console.log(80000)
        if (res1.status != 200) {
           ElMessageBox.alert('Ocorreu um erro ' + res1.data.message)
        } else {
            const data = res1.data.categories
            categories.splice(0)
            data.forEach((element: Category) => {
                categories.push(element)
            });
        }

        await getProduct()

        loading.value = false
    })

    const update = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                loading.value = true
                const data = new FormData()
                data.append('name', product.name)
                data.append('price', product.price.toString())
                data.append('quantity', (product.quantity ?? 0).toString())
                if (product.active) { data.append('active', '1') } else { data.append('active', '0') }
                data.append('description', product.description);
                product.promoction && data.append('promoction', product.promoction?.toString());
                
                // categorias
                product.categories?.forEach((c, i) => {
                    data.append(`categories[${i}]`, c.toString())
                })

                const res = await Api.put('admin/products/' + id, product, data)
                console.log(res.data)

                if (res.status == 200) {
                    ElMessage.success({message: 'Actualizado com sucesso'})
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                loading.value = false
            }
        })
    }

    const removeProp = async (prop: Property) => {
        prop.loading = true
        await sendProp(Object.assign({}, prop, {value: ''}))
        prop.loading = false
    }

    const sendProp = async (prop: Property) => {
        prop.loading = true
        const form = new FormData()
        form.append(`properties[${prop.property}]`, prop.value)
        const res = await Api.post(`admin/products/${product.id}`, {}, form)
        console.log(res.data)
        if (res.status == 200) {
            product.properties = res.data.product.properties
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }

        editProp.value = -1
        prop.loading = false
    }

    const openModal = () => {
        store.commit('setOpenModal', 4)
    }

    // atualizar props depois de adicionar
    store.watch((state, getter) => getter.openModal, async (n, o) => {
        o == 4 && await getProduct()
    })

    watchEffect(() => {
        console.log(checks.value)
    })

return (_ctx: any,_cache: any) => {
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      header: product.name
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_skeleton, {
          loading: loading.value,
          animated: "",
          rows: 12
        }, {
          default: _withCtx(() => [
            (!product.id)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  justify: "center",
                  align: "middle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      sm: 12,
                      lg: 7
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_result, {
                          icon: "error",
                          title: "Produto não encontrado",
                          "sub-title": "O produto que procura não foi encontrado, por favor verifique se consta da lista"
                        }, {
                          extra: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              type: "primary",
                              icon: "View"
                            }, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode("Produtos", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_row, {
                  key: 1,
                  gutter: 20
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      md: 16,
                      lg: 14
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                          rules: rules,
                          ref_key: "formRef",
                          ref: formRef,
                          model: product,
                          disabled: updating.value,
                          "label-position": "top"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_row, {
                              gutter: 20,
                              justify: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  sm: 24,
                                  md: 10
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Nome do produto",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInput), {
                                          modelValue: product.name,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((product.name) = $event)),
                                          name: "name"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  sm: 24,
                                  md: 7
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Produto activo",
                                      prop: "active"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_switch, {
                                          style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"},
                                          "active-text": "Activo",
                                          "inactive-text": "Inativo",
                                          modelValue: product.active,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((product.active) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  sm: 24,
                                  md: 7
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Quantidade em estoque",
                                      prop: "quantity"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input_number, {
                                          name: "quantity",
                                          step: 1,
                                          modelValue: product.quantity,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((product.quantity) = $event)),
                                          min: 0,
                                          class: "col-12"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { sm: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_row, { gutter: 20 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, {
                                          sm: 24,
                                          md: 7
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "preço de promoção",
                                              prop: "promoction"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_input_number, {
                                                  name: "promoction",
                                                  modelValue: product.promoction,
                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((product.promoction) = $event)),
                                                  min: 0,
                                                  class: "col-12"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          sm: 24,
                                          md: 7
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_row, { gutter: 20 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_form_item, {
                                                      label: "preço normal",
                                                      prop: "price"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_input_number, {
                                                          name: "price",
                                                          modelValue: product.price,
                                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((product.price) = $event)),
                                                          min: 0.001,
                                                          class: "col-12"
                                                        }, null, 8, ["modelValue"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          sm: 24,
                                          md: 10
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "Categorias",
                                              prop: "categories"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_select, {
                                                  modelValue: product.categories,
                                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((product.categories) = $event)),
                                                  name: "categories",
                                                  multiple: "",
                                                  filterable: true
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories, (c) => {
                                                      return (_openBlock(), _createBlock(_component_el_option, {
                                                        value: c.id,
                                                        label: c.name,
                                                        key: c.id
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(c.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["value", "label"]))
                                                    }), 128))
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Descricao",
                                      prop: "description"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInput), {
                                          type: "textarea",
                                          clearable: "",
                                          name: "descricao",
                                          modelValue: product.description,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((product.description) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, { gutter: 25 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { class: "col-auto" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElButton), {
                                      plain: "",
                                      type: "primary",
                                      size: "large",
                                      loading: updating.value,
                                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (update(formRef.value)), ["prevent"]))
                                    }, {
                                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                        _createTextVNode(" Salvar alterações ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["loading"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["rules", "model", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      md: 8,
                      lg: 10,
                      style: {"height":"100%"},
                      class: "overflow-y-scroll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, null, {
                          default: _withCtx(() => [
                            _cache[15] || (_cache[15] = _createElementVNode("h6", null, "Galeria", -1)),
                            (checks.value.length > 0)
                              ? (_openBlock(), _createBlock(_unref(ElButton), {
                                  key: 0,
                                  plain: "",
                                  type: "danger",
                                  onClick: deleteChecks
                                }, {
                                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                    _createTextVNode("Eliminar seleciondas", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_divider)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 20 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.images, (img) => {
                              return (_openBlock(), _createBlock(_component_el_col, {
                                sm: 12,
                                md: 8,
                                key: (img as Image).id
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "delete-check",
                                    name: "checks[]",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((checks).value = $event)),
                                    value: (img as Image).id
                                  }, null, 8, _hoisted_2), [
                                    [_vModelCheckbox, checks.value]
                                  ]),
                                  (isVideoFile((img as Image).url ?? ''))
                                    ? (_openBlock(), _createElementBlock("video", _hoisted_3, [
                                        _createElementVNode("source", {
                                          src: `${_unref(Api).publicUrl}images/products/${(img as Image).url}`
                                        }, null, 8, _hoisted_4)
                                      ]))
                                    : (_openBlock(), _createBlock(_component_el_image, {
                                        key: 1,
                                        alt: "",
                                        src: `${_unref(Api).publicUrl}images/products/${(img as Image).url}`,
                                        class: "col-12"
                                      }, null, 8, ["src"]))
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _cache[17] || (_cache[17] = _createElementVNode("h6", null, "Adicionar imagens", -1)),
                        _createElementVNode("input", {
                          type: "file",
                          multiple: "",
                          name: "files",
                          onChange: handleFiles
                        }, null, 32),
                        _createVNode(_unref(ElButton), {
                          plain: "",
                          type: "primary",
                          class: "my-3",
                          onClick: sendImages
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("Adicionar imagens", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { md: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_divider),
                        _cache[19] || (_cache[19] = _createElementVNode("h6", null, "Propriedades", -1)),
                        _createVNode(_component_el_row, {
                          gutter: 10,
                          class: "py-4 px-2"
                        }, {
                          default: _withCtx(() => [
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "col-12 py-1" }, "Adicionar propriedade", -1)),
                            _createVNode(_unref(ElInput), {
                              modelValue: newProp.property,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newProp.property) = $event)),
                              placeholder: "Inserir Propriedade",
                              class: "col-4 mx-2"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(ElInput), {
                              modelValue: newProp.value,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newProp.value) = $event)),
                              placeholder: "Inserir valor",
                              class: "col-4 mx-2"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(ElButton), {
                              loading: newProp.loading,
                              onClick: _cache[11] || (_cache[11] = () => sendProp(newProp))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElIcon), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Plus)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        }),
                        (product.properties?.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Nenhuma propriedade adicionada "))
                          : (product.properties)
                            ? (_openBlock(), _createBlock(PersonalTable, {
                                key: 1,
                                rows: 10,
                                loading: false,
                                data: product.properties,
                                cols: [
                                        {prop: 'id', label: '#', sortable: true}
                                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    label: "Propriedade",
                                    "class-name": "auto",
                                    "min-width": 150
                                  }, {
                                    default: _withCtx((data) => [
                                      (editProp.value == data.row.id)
                                        ? (_openBlock(), _createBlock(_unref(ElInput), {
                                            key: 0,
                                            modelValue: data.row.property,
                                            "onUpdate:modelValue": ($event: any) => ((data.row.property) = $event),
                                            placeholder: "Inserir Propriedade"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(data.row.property), 1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    label: "Valor",
                                    "class-name": "auto",
                                    "min-width": 150
                                  }, {
                                    default: _withCtx((data) => [
                                      (editProp.value == data.row.id)
                                        ? (_openBlock(), _createBlock(_unref(ElInput), {
                                            key: 0,
                                            modelValue: data.row.value,
                                            "onUpdate:modelValue": ($event: any) => ((data.row.value) = $event),
                                            placeholder: "Inserir valor da propriedade"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.row.value), 1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    label: "Acções",
                                    "class-name": "auto",
                                    "min-width": 150
                                  }, {
                                    default: _withCtx((data) => [
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          (editProp.value == data.row.id)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                                _createVNode(_unref(ElButton), {
                                                  loading: data.row.loading,
                                                  type: "success",
                                                  icon: "Finished",
                                                  title: "Editar",
                                                  onClick: () => sendProp(data.row)
                                                }, null, 8, ["loading", "onClick"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                                _createVNode(_unref(ElButton), {
                                                  loading: data.row.loading,
                                                  type: "warning",
                                                  icon: "EditPen",
                                                  title: "Editar",
                                                  onClick: () => editProp.value = data.row.id
                                                }, null, 8, ["loading", "onClick"])
                                              ])),
                                          _createElementVNode("span", _hoisted_10, [
                                            _createVNode(_unref(ElButton), {
                                              loading: data.row.loading,
                                              type: "danger",
                                              icon: "Delete",
                                              title: "Eliminar",
                                              onClick: () => removeProp(data.row)
                                            }, null, 8, ["loading", "onClick"])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["header"])
  ]))
}
}

})